/**
 * Function to sort an array of
 * objects alphabetically
 * @param {Array} data
 * @param {string} searchKey
 */

import { constants } from './constants'
import { groupBy } from 'lodash'
import { formatDateOnList } from './timeHandler'

const { SORT_DIRECTION, SORT_TYPE } = constants

const sortDates = (firstKey, secondKey, isDescending) => {
    const firstDateValue = new Date(firstKey)
    const secondDateValue = new Date(secondKey)
    const comparison = firstDateValue - secondDateValue
    return isDescending ? -comparison : comparison
}

const sortAlphaNumeric = (firstKey, secondKey, isDescending) => {
    const firstValue = isNaN(firstKey) ? firstKey : parseFloat(firstKey)
    const secondValue = isNaN(secondKey) ? secondKey : parseFloat(secondKey)

    if (firstValue > secondValue) {
        return isDescending ? -1 : 1
    }
    if (firstValue < secondValue) {
        return isDescending ? 1 : -1
    }
    return 0
}

export const sortHandler = (
    data,
    searchKey,
    sortType = SORT_TYPE.ALPHA_NUMERIC,
    sortDirection = SORT_DIRECTION.ASCENDING
) => {
    const isDescending = sortDirection === SORT_DIRECTION.DESCENDING

    return data?.length > 0
        ? data
              ?.slice()
              ?.sort((a, b) =>
                  sortType === SORT_TYPE.ALPHA_NUMERIC
                      ? sortAlphaNumeric(
                            a[searchKey],
                            b[searchKey],
                            isDescending
                        )
                      : sortDates(a[searchKey], b[searchKey], isDescending)
              )
        : []
}

export const defaultSortConfig = {
    sortKey: 'date_received',
    sortType: constants.SORT_TYPE.DATE,
    sortDirection: constants.SORT_DIRECTION.DESCENDING
}

export const sortAndGroupList = (list, sortConfig = defaultSortConfig) => {
    const sortedList = sortHandler(
        list,
        sortConfig.sortKey,
        sortConfig.sortType,
        sortConfig.sortDirection
    )
    const formattedListDate =
        formatDateOnList(sortedList, sortConfig.sortKey) || []
    return groupBy(formattedListDate, sortConfig.sortKey)
}

export const sortPotentialClients = (clients) => {
    const duplicatedClients = []
    const notInterestedClients = []
    const paymentNoPackageClients = []
    const otherPotentialClients = []

    const madePaymentButNoPackage = (client) =>
        client.all_enrollment === 0 && client.balance > 0

    clients?.forEach((client) => {
        if (client.duplicate) {
            duplicatedClients.push(client)
        } else if (client.isNotInterested) {
            notInterestedClients.push(client)
        } else if (madePaymentButNoPackage(client)) {
            paymentNoPackageClients.push(client)
        } else {
            otherPotentialClients.push(client)
        }
    })
    return [
        ...paymentNoPackageClients,
        ...otherPotentialClients,
        ...notInterestedClients,
        ...duplicatedClients
    ]
}
